import { useState, useEffect } from "react";
import axios from "axios";
import { FaTrash } from "react-icons/fa"; // Import bin icon
import { useNavigate } from "react-router-dom";


function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let cookie of cookies) {
        let [key, value] = cookie.split("=");
        if (key === name) return decodeURIComponent(value);
    }
    return null;
}


const Access = () => {
    const [selectedModule, setSelectedModule] = useState(null);
    const [selectedOrganization, setSelectedOrganization] = useState(null);
    const [modules, setModules] = useState([]);
    const [organizations, setOrganizations] = useState([]);
    const [usersWithAccess, setUsersWithAccess] = useState([]);
    const [showEmailInput, setShowEmailInput] = useState(false);
    const [emailInput, setEmailInput] = useState("");
    const [showRoleInput, setShowRoleInput] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [failMessage, setfailMessage] = useState("");
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [userToDelete, setUserToDelete] = useState(null);
    const [roles, setRoles] = useState([]);
    const [selectedRole, setSelectedRole] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState('All');
    const [searchQuery, setSearchQuery] = useState('');

    const [token, setToken] = useState(getCookie("accessToken"))
    const navigate = useNavigate();

    const safeUsersWithAccess = Array.isArray(usersWithAccess) ? usersWithAccess : [];
    const categories = ['All', ...new Set(safeUsersWithAccess.map(item => item.role))];




    const filteredData = safeUsersWithAccess.filter(item => {
        const matchesCategory = selectedCategory === 'All' || item.role === selectedCategory;
        const matchesSearch =
            item.firstName.toLowerCase().includes(searchQuery.toLowerCase()) ||
            item.lastName.toLowerCase().includes(searchQuery.toLowerCase()) ||
            item.email.toLowerCase().includes(searchQuery.toLowerCase());

        return matchesCategory && matchesSearch;
    });

    useEffect(() => {

        setToken(getCookie("accessToken"))
        if (!token) {
            navigate("/"); // Redirect to home page

        }

        axios
            .get("https://onehum-backend.acuitas360.com/module", {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            })
            .then((response) => { setModules(response.data); }
            )
            .catch((error) => console.error("Error fetching modules:", error));

        axios
            .get("https://onehum-backend.acuitas360.com/organization", {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            })
            .then((response) => {
                setOrganizations(response.data);
            }
            )
            .catch((error) => console.error("Error fetching organizations:", error));

        setUsersWithAccess(selectedModule ? modules.find(mod => mod.id == selectedModule.id).users : []);
    }, [successMessage, showDeletePopup, showEmailInput]);

    const handleModuleSelection = (module) => {
        setSelectedModule(module);
        setUsersWithAccess(module ? module.users : []);
    };

    const handleGiveAccess = () => {
        setShowEmailInput(true);
        setShowRoleInput(false);
    };

    const handleGiveAccessByRole = () => {
        setShowRoleInput(true);
        setShowEmailInput(false);
    };


    const handleBack = () => {
        setShowEmailInput(false);
        setShowRoleInput(false);
        setEmailInput("");
    };

    const handleRoleSubmit = async () => {

        if (!selectedRole) {
            alert("Please select role.");
            return;
        }


        try {
            const response = await axios.post(`https://onehum-backend.acuitas360.com/user/assign-module/${selectedModule.id}`, {
                role: selectedRole,
            }, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });

            // console.log(response.data.count);

            setSuccessMessage(`${response.data.count} users successfully added!`);
            setUsersWithAccess(response.data); // Update users list with response data
            setEmailInput("");
            setShowEmailInput(false);

            setTimeout(() => {
                setSuccessMessage("");
            }, 3000);
        } catch (error) {
            setfailMessage(`Failed to add users!!`);
            setEmailInput("");
            setShowEmailInput(false);

            setTimeout(() => {
                setfailMessage("");
            }, 3000);

        }

        setShowRoleInput(false);
        setSelectedRole(null)

    }

    const handleSubmit = async () => {
        if (!emailInput.trim()) {
            alert("Please enter at least one email.");
            return;
        }


        try {
            const response = await axios.post(`https://onehum-backend.acuitas360.com/module/assign-users/${selectedModule.id}`, {
                emails: emailInput.split(",").map((email) => email.trim())
            }, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });

            setSuccessMessage(`Users successfully added!`);
            setUsersWithAccess(response.data); // Update users list with response data
            setEmailInput("");
            setShowEmailInput(false);

            setTimeout(() => {
                setSuccessMessage("");
            }, 3000);
        } catch (error) {
            console.error("Error adding users:", error);
            setfailMessage(`Failed to add users!!`);
            setUsersWithAccess(error); // Update users list with response data
            setEmailInput("");
            setShowEmailInput(false);

            setTimeout(() => {
                setfailMessage("");
            }, 3000);
        }
    };

    const handleDeleteClick = (user) => {
        setUserToDelete(user);
        setShowDeletePopup(true);
    };

    const handleConfirmDelete = async () => {
        if (!userToDelete || !selectedModule) return;

        try {
            await axios.delete(`https://onehum-backend.acuitas360.com/user/${userToDelete.id}/remove-module/${selectedModule.id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });

            setSuccessMessage("User access removed!");
            setUsersWithAccess(usersWithAccess.filter((u) => u.id !== userToDelete.id));
            setShowDeletePopup(false);
            setUserToDelete(null);

            setTimeout(() => {
                setSuccessMessage("");
            }, 2000);
        } catch (error) {
            console.error("Error removing user:", error);
            alert("Failed to remove user access.");
        }
    };

    return (
        <div className="p-4 bg-gray-100 rounded " style={{ maxHeight: "90vh" }}>
            {/* Select Organization Dropdown */}
            <label className="block mb-2 text-lg font-medium">Select Organization:</label>
            <select
                className="w-full p-2 border rounded mb-4"
                onChange={(e) => {
                    const organization = organizations.find((org) => org.id === parseInt(e.target.value));
                    setSelectedOrganization(organization);
                    setRoles([...new Set(organization.user.map(item => item.role))])
                    setSelectedModule(null);
                    setUsersWithAccess([]);
                    setShowEmailInput(false);
                    setSearchQuery("");
                    setSelectedCategory("All");
                }}
                value={selectedOrganization ? selectedOrganization.id : ""}
                disabled={showEmailInput || showRoleInput}
            >
                <option value="">-- Select --</option>
                {organizations.map((organization) => (
                    <option key={organization.id} value={organization.id}>
                        {organization.name}
                    </option>
                ))}
            </select>

            {/* Select Module Dropdown */}
            <label className="block mb-2 text-lg font-medium">Select Module:</label>
            <select
                className="w-full p-2 border rounded mb-4"
                onChange={(e) => {
                    const module = modules.find((m) => m.id === parseInt(e.target.value));
                    handleModuleSelection(module);
                    setSearchQuery("");
                    setSelectedCategory("All");
                }}
                value={selectedModule ? selectedModule.id : ""}
                disabled={!selectedOrganization || showEmailInput || showRoleInput}
            >
                <option value="">-- Select --</option>
                {modules
                    .filter((module) => module.organization.id === selectedOrganization?.id)
                    .map((module) => (
                        <option key={module.id} value={module.id}>
                            {module.title}
                        </option>
                    ))}
            </select>

            {/* Give Access Button */}
            {selectedModule && !showEmailInput && !showRoleInput && (
                <div className="flex gap-4 mb-4">
                    <button className=" p-2 bg-blue-500 text-white rounded hover:bg-blue-600" onClick={handleGiveAccess}>
                        Add Users Manually
                    </button>
                    <button className=" p-2 bg-green-500 text-white rounded hover:bg-green-600" onClick={handleGiveAccessByRole}>
                        Add Users by Role
                    </button>
                </div>
            )}



            {/* Add Email Input Section */}
            {showEmailInput && (
                <div className="bg-white p-4 rounded shadow-md">
                    <label className="block mb-2 text-lg font-medium">Add Email of Users to give Access:</label>
                    <textarea
                        className="w-full p-2 border rounded mb-4"
                        placeholder="Enter emails separated by commas"
                        value={emailInput}
                        onChange={(e) => setEmailInput(e.target.value)}
                    />
                    <div className="flex justify-between">
                        <button className="p-2 bg-gray-500 text-white rounded hover:bg-gray-600" onClick={handleBack}>
                            Back
                        </button>
                        <button className="p-2 bg-green-500 text-white rounded hover:bg-green-600" onClick={handleSubmit}>
                            Submit
                        </button>
                    </div>
                </div>
            )}


            {showRoleInput && (
                <div className="bg-white p-4 rounded shadow-md">
                    <label className="block mb-2 text-lg font-medium">Select Role:</label>
                    <select className="w-full p-2 border rounded mb-4"
                        onChange={(e) => {
                            setSelectedRole(e.target.value)
                        }}
                        value={selectedRole ? selectedRole.id : ""}
                    >
                        <option value="">-- Select Role --</option>
                        {roles
                            .map((module, id) => (
                                <option key={id} value={module}>
                                    {module}
                                </option>
                            ))}
                    </select>


                    <div className="flex justify-between">
                        <button className="p-2 bg-gray-500 text-white rounded hover:bg-gray-600" onClick={handleBack}>
                            Back
                        </button>
                        <button className="p-2 bg-green-500 text-white rounded hover:bg-green-600" onClick={handleRoleSubmit}>
                            Submit
                        </button>
                    </div>
                </div>
            )}

            {/* Success Message */}
            {successMessage && (
                <div className="text-green-600 font-semibold mt-4 text-center bg-green-200 p-2 rounded fixed w-full top-0 left-0">
                    {successMessage}
                </div>
            )}

            {/* failed Message */}
            {failMessage && (
                <div className="text-red-600 font-semibold mt-4 text-center bg-red-200 p-2 rounded fixed w-full top-10 left-0">
                    {failMessage}
                </div>
            )}

            {/* Users with Access List */}
            {usersWithAccess.length > 0 && (
                <div className="bg-white p-4 rounded shadow-md mt-4">
                    <h3 className="text-lg font-semibold mb-4 text-center">
                        Users in {selectedOrganization.name} with access to {selectedModule.title}
                    </h3>
                    <div className="flex justify-between items-center mb-4">
                        {/* Filter by Category */}
                        <div className="flex items-center">
                            <label className="mr-2">Filter by Role:</label>
                            <select
                                className="border p-2 rounded w-56"
                                value={selectedCategory}
                                onChange={(e) => setSelectedCategory(e.target.value)}
                            >
                                {categories.map((category, index) => (
                                    <option key={index} value={category}>
                                        {category}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* Search Bar */}
                        <div className="flex items-center">
                            <label className="mr-2">Search by Name or Email:</label>
                            <input
                                type="text"
                                className="border p-2 rounded w-56"
                                placeholder="Search items..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                        </div>
                    </div>

                    <ul className="divide-y divide-gray-300">
                        {filteredData.map((user, index) => (
                            <li key={user.id} className="flex items-center justify-between p-3 bg-gray-50 hover:bg-gray-100 rounded-md transition">
                                <div className="flex items-center gap-3">

                                    {/* Serial Number */}
                                    <span className="font-semibold text-gray-700 w-6">{index + 1}.</span>

                                    {/* User Initials */}
                                    <div className="w-10 h-10 flex items-center justify-center bg-blue-500 text-white font-semibold rounded-full">
                                        {user.firstName.charAt(0)}
                                        {user.lastName.charAt(0)}
                                    </div>

                                    {/* User Details */}
                                    <div className="w-64">
                                        <p className="font-medium">{user.firstName} {user.lastName}</p>
                                        <p className="text-sm text-gray-600">{user.email}</p>
                                    </div>
                                    <p className="text-sm text-gray-600">Role: <span className="font-medium">{user.role}</span></p>

                                </div>

                                {/* Delete Icon */}
                                <FaTrash className="text-red-500 cursor-pointer text-xl" onClick={() => handleDeleteClick(user)} />
                            </li>
                        ))}
                    </ul>
                </div>
            )}

            {/* Delete Confirmation Popup */}
            {showDeletePopup && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white p-6 rounded shadow-md text-center">
                        <p className="text-lg font-medium mb-4">Do you want to remove this user's access?</p>
                        <div className="flex justify-center gap-4">
                            <button className="p-2 bg-gray-500 text-white rounded hover:bg-gray-600" onClick={() => setShowDeletePopup(false)}>
                                No
                            </button>
                            <button className="p-2 bg-red-500 text-white rounded hover:bg-red-600" onClick={handleConfirmDelete}>
                                Yes
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Access;
